export const defaultConfig = {
    // baseAPIUrl: "https://laravel9.etrueconcept.com/ecoachpro/api/",
   baseAPIUrl: "https://app.ecoachpro.net/backend/api/",
    Userimage: "https://ecoachpro-training-videos.s3.eu-north-1.amazonaws.com/",
    Skilltypesimage: "https://ecoachpro-training-videos.s3.eu-north-1.amazonaws.com/",
    Skillvideos: "https://ecoachpro-training-videos.s3.eu-north-1.amazonaws.com/",
    Skillvideoss:"https://ecoachpro-training-videos.s3.eu-north-1.amazonaws.com/",
    Imagepath:"https://ecoachpro-training-videos.s3.eu-north-1.amazonaws.com/"
    };